<script setup lang="ts">
  import { StatusStateMap, statusToIconMap, statusToCssClassesMap } from '@/components/common/StatusIcon/statusIcon';
  import SvgIcon from '@/components/common/SvgIcon/SvgIcon.vue';
  import { components } from '@/cypaths';
  import type { IconSize } from '@/types';

  defineOptions({ name: 'StatusIcon' });

  withDefaults(
    defineProps<{
      status: StatusStateMap;
      size?: IconSize;
    }>(),
    {
      size: 'smaller',
    },
  );
</script>

<template>
  <SvgIcon
    role="status"
    :icon="statusToIconMap[status]"
    :size="size"
    :data-cy="components.STATUS_ICON"
    class="status-icon h-auto flex-none align-middle"
    :class="statusToCssClassesMap[status]"
  />
</template>
